export default "__VITE_ASSET__BgrHcbop__"